"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TRANSITION_TIMING_FUNCTION = exports.DEFAULT_VERTICAL = exports.DEFAULT_UNTIDY_ON_HOVER = exports.DEFAULT_TRANSITION_SPEED_MULTIPLIER = exports.DEFAULT_TRANSITION_STYLE = exports.DEFAULT_LINE_HEIGHT = exports.DEFAULT_FONT_SIZE = exports.DEFAULT_FONT_FAMILY = exports.DEFAULT_FONT_STYLE = exports.DEFAULT_HEIGHT = exports.DEFAULT_WIDTH = exports.DEFAULT_FONT_WEIGHT = exports.DEFAULT_CANVAS = void 0;

/* eslint-env browser */
const DEFAULT_CANVAS = typeof document !== `undefined` ? document.createElement('canvas') : null;
exports.DEFAULT_CANVAS = DEFAULT_CANVAS;
const DEFAULT_FONT_WEIGHT = 400;
exports.DEFAULT_FONT_WEIGHT = DEFAULT_FONT_WEIGHT;
const DEFAULT_WIDTH = 100;
exports.DEFAULT_WIDTH = DEFAULT_WIDTH;
const DEFAULT_HEIGHT = 100;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
const DEFAULT_FONT_STYLE = 'normal';
exports.DEFAULT_FONT_STYLE = DEFAULT_FONT_STYLE;
const DEFAULT_FONT_FAMILY = 'Georgia';
exports.DEFAULT_FONT_FAMILY = DEFAULT_FONT_FAMILY;
const DEFAULT_FONT_SIZE = '20px';
exports.DEFAULT_FONT_SIZE = DEFAULT_FONT_SIZE;
const DEFAULT_LINE_HEIGHT = 1.3;
exports.DEFAULT_LINE_HEIGHT = DEFAULT_LINE_HEIGHT;
const DEFAULT_TRANSITION_STYLE = 'constant';
exports.DEFAULT_TRANSITION_STYLE = DEFAULT_TRANSITION_STYLE;
const DEFAULT_TRANSITION_SPEED_MULTIPLIER = 1;
exports.DEFAULT_TRANSITION_SPEED_MULTIPLIER = DEFAULT_TRANSITION_SPEED_MULTIPLIER;
const DEFAULT_UNTIDY_ON_HOVER = false;
exports.DEFAULT_UNTIDY_ON_HOVER = DEFAULT_UNTIDY_ON_HOVER;
const DEFAULT_VERTICAL = false;
exports.DEFAULT_VERTICAL = DEFAULT_VERTICAL;
const DEFAULT_TRANSITION_TIMING_FUNCTION = 'ease';
exports.DEFAULT_TRANSITION_TIMING_FUNCTION = DEFAULT_TRANSITION_TIMING_FUNCTION;